<template>
  <div class="flex h-full flex-col bg-white">
    <!-- Loading state -->
    <div v-if="isLoading" class="flex flex-1 items-center justify-center">
      <div class="text-center text-gpx_gray-700">
        <div
          class="mx-auto mb-2 size-8 animate-spin rounded-full border-2 border-gpx_gray-800 border-t-blue-500"
        ></div>
        <p>Loading insight...</p>
      </div>
    </div>

    <!-- Not found state -->
    <div v-else-if="!insight" class="flex flex-1 items-center justify-center">
      <div class="text-center text-gpx_gray-700">
        <p>Insight not found</p>
      </div>
    </div>

    <!-- Content loaded state -->
    <div v-else class="flex-1 overflow-y-auto border-t border-gpx_gray-900 p-6">
      <!-- Show raw markdown content -->
      <MarkdownViewer
        v-if="insight.result"
        :content="insight.result"
        class="h-full"
      />

      <!-- Fallback for empty result -->
      <div v-else class="text-center text-gpx_gray-700">
        <p>No content available for this insight</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useInsights } from '@/composables/useInsights';
import MarkdownViewer from '@/components/_common/MarkdownViewer.vue';

const route = useRoute();
const { getInsightById, isLoading, insights } = useInsights();

// Get the current insight based on route parameter
const insight = computed(() => {
  const id = route.params.id;
  if (!id || isLoading.value || !insights.value) return null;

  const foundInsight = getInsightById(id);
  return foundInsight || null;
});
</script>
